import { shallowRef } from "vue";

import {
  ApprovalIcon,
  CheckIcon,
  ConditionallyAcceptedIcon,
  InfiniteIcon,
  PublishedWithChangesIcon,
  UnpublishedIcon,
} from "@/components/shared/icons";

export const ACCEPTANCE_STATUS_ALL = "All";

export const ACCEPTANCE_STATUS = {
  readyForReview: "Ready for Review",
  accepted: "Accepted",
  notAccepted: "Not Accepted",
  provisionallyAccepted: "Provisionally Accepted",
  conditionallyAccepted: "Conditionally Accepted",
};

export const HOST_ACCEPTED_CONDITION = {
  pendingAcceptanceFromHostInstitution: "Pending Acceptance from Host Institution",
  pendingSubmissionOfAdditionalLetterOfRecommendation: "Pending Submission of Additional Letter of Recommendation",
  pendingSubmissionFromHomeInstitutionAboutJudicialHistory:
    "Pending Submission from Home Institution about Judicial History",
  pendingNotificationOfApprovalFromHomeInstitution: "Pending Notification of Approval from Home Institution",
  pendingUpdatedTranscript: "Pending Updated Transcript",
  other: "Other",
};

export const getAcceptanceStatusIcon = (status) => {
  switch (status) {
    case ACCEPTANCE_STATUS.readyForReview:
      return shallowRef(ApprovalIcon);
    case ACCEPTANCE_STATUS.accepted:
      return shallowRef(CheckIcon);
    case ACCEPTANCE_STATUS.notAccepted:
      return shallowRef(UnpublishedIcon);
    case ACCEPTANCE_STATUS.provisionallyAccepted:
      return shallowRef(PublishedWithChangesIcon);
    case ACCEPTANCE_STATUS.conditionallyAccepted:
      return shallowRef(ConditionallyAcceptedIcon);
    default:
      return shallowRef(InfiniteIcon);
  }
};
